var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { Autocomplete, FormHelperText, Stack, TextField, Tooltip } from '@mui/material';
import TagChip from '../../tagChip/components/TagChip';
import classNames from 'classnames';
import AccurityIcon from '../../icon/components/AccurityIcon';
var FORBIDDEN_CHARACTERS_REGEXP = new RegExp('[;\\s]', 'gi');
var TagField = function (_a) {
    var name = _a.name, label = _a.label, value = _a.value, options = _a.options, onChange = _a.onChange, searchHandler = _a.searchHandler, onTagClick = _a.onTagClick, disableNewTagCreation = _a.disableNewTagCreation, disabled = _a.disabled, errorMessage = _a.errorMessage, _b = _a.maxTagLength, maxTagLength = _b === void 0 ? 20 : _b, coloring = _a.coloring, tooltip = _a.tooltip, inherited = _a.inherited;
    var _c = useState(false), isPopupOpen = _c[0], setIsPopupOpen = _c[1];
    var _d = useState(''), inputValue = _d[0], setInputValue = _d[1];
    var optionsFilter = disableNewTagCreation ? undefined :
        function (tags, params) {
            // Suggest the creation of a new value
            if (params.inputValue !== '' && !tags.find(function (q) { return q.name.toLowerCase() === params.inputValue.toLowerCase(); })) {
                tags.unshift({ name: params.inputValue });
            }
            return tags;
        };
    var onChangeHandler = function (e, tags) {
        var newTag = tags[tags.length - 1];
        // do not create duplicates
        if (tags.filter(function (q) { return q.name.toLowerCase() === newTag.name.toLowerCase(); }).length > 1) {
            tags.pop();
            return;
        }
        onChange(tags);
    };
    var onInputChangeHandler = function (e, text) {
        // remove forbidden chars
        text = text.replace(FORBIDDEN_CHARACTERS_REGEXP, '');
        text = text.trim().slice(0, maxTagLength);
        setInputValue(text);
        searchHandler(text);
        setIsPopupOpen(!!text);
    };
    return (React.createElement("div", { className: classNames('tagField', { disabled: disabled, 'tagField--revisionColoring': !!coloring }) },
        React.createElement(Stack, { position: "absolute", right: "0", direction: "row", sx: { zIndex: 3 } },
            inherited &&
                React.createElement(Tooltip, { title: "Inherited" },
                    React.createElement(AccurityIcon, { iconName: "mui:LayersOutlined", fontSize: "small", color: "secondary700" })),
            tooltip &&
                React.createElement(Tooltip, { title: tooltip },
                    React.createElement(AccurityIcon, { iconName: "mui:HelpOutline", fontSize: "small", color: "secondary700" }))),
        React.createElement(Autocomplete, { multiple: true, disabled: disabled, renderInput: function (params) { return React.createElement(TextField, __assign({}, params, { error: !!errorMessage, label: label })); }, renderTags: function (tags, getTagProps) {
                return tags.map(function (tag, index) {
                    var _a = getTagProps({ index: index }), onDelete = _a.onDelete, className = _a.className;
                    return (React.createElement(TagChip, { key: index, label: tag.name, className: className, onClick: function () { return onTagClick ? onTagClick(tag) : undefined; }, onDelete: !disabled ? onDelete : undefined, coloring: coloring ? coloring[index] : undefined }));
                });
            }, autoHighlight: true, value: value, inputValue: inputValue, options: __spreadArray(__spreadArray([], value, true), options, true), getOptionLabel: function (option) { return option.name; }, filterSelectedOptions: true, filterOptions: optionsFilter, forcePopupIcon: false, clearIcon: null, open: isPopupOpen, onChange: onChangeHandler, onInputChange: onInputChangeHandler, onClose: function () { return setIsPopupOpen(false); } }),
        (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.trim()) && React.createElement(FormHelperText, null, errorMessage)));
};
export default TagField;
//# sourceMappingURL=TagField.js.map